import { Route } from "react-router-dom";
import VehicleCategoryScreen from "../../../container/Vehicles/VehicleCategoryScreen";
import CreateVehicleCategory from "../../../container/Vehicles/VehicleCategoryScreen/CreateVehicleCategory";
import { APP_URLS } from "../../../utils/constant";


const VehicleCategoryRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_CATEGORY.HOME}
          element={<VehicleCategoryScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_CATEGORY.CREATE}
          element={<CreateVehicleCategory />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_CATEGORY.EDIT}
          element={<CreateVehicleCategory isEdit={true} />}
        />
      )}
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_CATEGORY.COPY}
          element={<CreateVehicleCategory isCopy={true} />}
        />
      )}
    </>
  );
};

export default VehicleCategoryRoutes;
